
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node",
      function () {
        return require("private-next-pages/en/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/smart-chains/tutorials/creating-a-smart-chain-on-a-single-node"])
      });
    }
  